/*
 * This file should import all substate types defined in feature modules,
 * to unfify and create the RootState.
 */
import { RouterState } from "react-router-redux";
import { FormState } from "redux-form";

import { State as ProductState } from "../routes/ProductCarousel";
import { State as PortfolioState } from "../routes/PortfolioCarousel";
import { State as ProdSearchState } from "../routes/ProductSearch";
import { State as Step1State } from "../routes/Step1";
import { State as StyleChoiceState } from "../routes/WizardStyleChoice";
import { State as LayoutChoiceState } from "../routes/WizardLayoutChoice";
import { State as ColorChoiceState } from "../routes/WizardColorChoice";
import { State as SummaryState } from "../routes/WizardSummary";
import { State as Step4State } from "../routes/Step4";
import { State as Step5State } from "../routes/Step5";
import { State as AuthState } from "../routes/Auth";

// TODO: Hardcoded for now: https://github.com/Microsoft/TypeScript/issues/5579
export interface FormsSubstate {
  step4Form: FormState;
}

export type RootState = {
  productCarousel: ProductState;
  portfolioCarousel: PortfolioState;
  auth: AuthState;
  form: FormsSubstate;
  routing: RouterState;
  productSearch: ProdSearchState;
  step1: Step1State;
  wizardStyleChoice: StyleChoiceState;
  wizardLayoutChoice: LayoutChoiceState;
  wizardColorChoice: ColorChoiceState;
  wizardSummary: SummaryState;
  step4: Step4State;
  step5: Step5State;
};

export type Action = {
  type: string;
  payload?: any; // TODO: Make payload type generic (I think means Action + Dispatch become generic too)
  [name: string]: any;
};

export type StateGetter = () => RootState;

export interface Dispatch {
  <R>(
    asyncAction: (dispatch: Dispatch, getState?: StateGetter, http?: any) => R,
  ): R;
  (action: Action): void;
}

/**
 * Makes a generic action creator accepting a payload of generic type.
 * @param action The action type to bind to the action creator.
 * @return Function that takes payload of specified type and returns an Action (the action creator).
 */
export const makeActionCreator = <PayloadType>(action: string) => (
  payload?: PayloadType,
): Action => ({
  type: action,
  payload,
});



// WEBPACK FOOTER //
// ./src/store/types.ts